import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { RequestedByField } from './RequestedByField';

export const RequestedByFieldExtension = FormFieldBlueprint.make({
  name: 'requested-by-field',
  params: {
    field: async () =>
      createFormField({
        name: 'RequestedByField',
        component: RequestedByField,
      }),
  },
});
